module.exports = __webpack_public_path__ + "img/358.5bdae29a.png";